import { useCallback, useState } from "react";


export function useAddressBarEvent() {
  const [enteredAddress, setEnteredAddress] = useState("");
  const [selectedSuggestion, setSelectedSuggestion] = useState("");
  const [areSuggestionsProvided, setAreSuggestionsProvided] = useState(false);

  const trackAddressBarEvent = useCallback(
    (addessSubmitted: string) => {
      const suggestionSubmitted = !Boolean(enteredAddress)
        ? false
        : !Boolean(selectedSuggestion);

      // segment.trackAddressBar({
      //   addressbar_enteredAddress: enteredAddress,
      //   addressbar_addressSubmitted: addessSubmitted,
      //   addressbar_selectedSuggestion: selectedSuggestion,
      //   addressbar_suggestionProvided: areSuggestionsProvided,
      //   addressbar_suggestionSubmitted: !suggestionSubmitted,
      // });
    },
    [enteredAddress, selectedSuggestion, areSuggestionsProvided],
  );

  const onChangeEnteredAddress = useCallback((newEnteredAddress: string) => {
    setEnteredAddress(newEnteredAddress);
    setSelectedSuggestion("");
  }, []);

  return {
    setEnteredAddress: onChangeEnteredAddress,
    setSelectedSuggestion,
    setAreSuggestionsProvided,
    trackAddressBarEvent,
  };
}
